import * as React from 'react';
import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import * as styles from './NatureBackgrounds.css';

export function NatureBackgrounds() {
    if (!IsMobileDevice()) {
        return null;
    }

	return (
        <span id="natureContainer">
			<img
				src="/images/backgrounds/dreamBackgroundParts/mountains.png"
				className={styles.image}
				style={{ bottom: 25, opacity: 0.3 }}
			/>
			<img
				src="/images/backgrounds/dreamBackgroundParts/trees.png"
				className={styles.image}
				style={{ bottom: 0, opacity: 0.8 }}
			/>
			<img
				src="/images/backgrounds/dreamBackgroundParts/clouds1.png"
				className={styles.image}
				style={{ bottom: 1000 }}
			/>
			<img
				src="/images/backgrounds/dreamBackgroundParts/clouds2.png"
				className={styles.image}
				style={{ bottom: 2000 }}
			/>
        </span>
	);
}